export default __webpack_public_path__ + "static/media/service-advisory.3afd3eab.jpg";